export default __webpack_public_path__ + "assets/images/pricing/2693c75c520dd99c3eccf856264e6abf.png";